"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.propsConfig = exports.popoverConfig = exports.intialValuesConfig = exports.initialTouchedConfig = exports.idPrefix = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _sub = _interopRequireDefault(require("date-fns/sub"));
var _utils = require("../../middleware/utils");
var _DefaultValues = require("./DefaultValues");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var calcName = exports.calcName = 'retirement';
var idPrefix = exports.idPrefix = "ri_";
var propsConfig = exports.propsConfig = {
  config: {
    API_URL: 'https://www-qa.massmutual.com/ict/calculate/retirement_v0.23.11',
    Steps: [{
      Title: 'How much should I save for retirement?',
      Description: '',
      SecondaryDescription: "See if you're on track for the retirement you want. MassMutual's Retirement Savings Calculator provides a look at your retirement nest egg and estimated monthly income.",
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Calculate',
        Icon: '',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'How much should I save for retirement?',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Edit your inputs & our assumptions',
        Icon: '',
        Variant: 'secondary',
        Side: 'L'
      },
      RightHandButton: {
        Label: 'View Disclosure',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: 'Next step',
        Description: 'Chat with a financial professional to help you retire on your terms.',
        CTAList: [{
          Label: 'Contact a Financial Professional',
          Href: '',
          Target: '',
          Variant: 'primary'
        }, {
          Label: 'Learn more about annuities',
          Href: '',
          Target: '',
          Variant: 'link'
        }]
      }
    }]
  }
};
var popoverConfig = exports.popoverConfig = {
  lifeExpectancy: "Average life expectancy from <a href=\"https://www.cdc.gov/nchs/fastats/life-expectancy.htm\" target=\"_blank\">CDC.gov</a> is 77.0. MassMutual uses a higher estimate to present a conservative view of how long your savings will last.",
  ssBenefit: "Enter $0 to exclude or leave blank to have estimate calculated. Click <a href=\"https://www.ssa.gov/OACT/quickcalc/index.html\" target=\"_blank\">here</a> to obtain your own estimate or <a href=\"https://secure.ssa.gov/RIL/SiView.do\" target=\"_blank\">here</a> to register with the SSA.",
  incomeGoalPercent: 'Represents the percent of your current income that you would like to have available in retirement.',
  salaryGrowth: 'Represents the annual increase in salary you expect to receive through retirement.',
  inflationRate: 'Represents the increase in overall price levels.',
  rorPreRetirement: 'Represents the assumed rate of return on your savings.',
  rorPostRetirement: 'Represents the assumed rate of return on your savings.'
};
var validationConfigPageOne = yup.object().shape({
  birthMonth: yup.number('Month must be a number').required('You must specify a valid month').min(1, 'Invalid Month').max(12, 'Invalid Month'),
  birthDay: yup.number('Day must be a number').required('You must specify a valid day').min(1, 'Invalid Day').max(31, 'Invalid Day'),
  birthYear: yup.number().required('You must specify a valid year'),
  birthdate: yup.date().typeError('Must be a valid date and between 18 and 100 years of age').required('Must be a valid date and between 18 and 100 years of age').min((0, _sub.default)(new Date(), {
    years: 100
  }), 'Must be a valid date and between 18 and 100 years of age').max((0, _sub.default)(new Date(), {
    years: 18
  }), 'Must be a valid date and between 18 and 100 years of age'),
  retirementAge: yup.number().transform(_utils.parseCurrencyString).required("Must enter a retirment age").max(90, 'Must be less than 90').test((info, meta) => {
    var {
      birthDay,
      birthMonth,
      birthYear
    } = meta.parent;
    var age = (0, _utils.calculateAge)(birthDay, birthMonth, birthYear);
    var ageLessThanRetirementAge = age < info;
    var retirementAgeGreaterThanMinimum = info > 61;
    return ageLessThanRetirementAge && retirementAgeGreaterThanMinimum ? true : meta.createError({
      path: meta.path,
      message: "Must be greater than ".concat(Math.max(age, 62), " and at most 90 years of age")
    });
  }),
  annualPay: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  contributionPercent: yup.number().transform(parseFloat).required('Must be between 0 and 100 %').min(0, 'Must be between 0 and 100 %').max(100, 'Must be between 0 and 100 %'),
  savings: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $100,000,000').min(0, 'Must be between $0 and $100,000,000').max(100000000, 'Must be between $0 and $100,000,000')
});
var validationConfigPageTwoAdditions = yup.object().shape({
  lifeExpectancy: yup.number().transform(_utils.parseCurrencyString).required('Must be between 67 and 120').min(67, 'Must be between 67 and 120').max(120, 'Must be between 67 and 120').test((info, meta) => {
    // must be greater than retirementAge, must be less than or equal to 120
    var lifeExpectancyGreaterThanRetirementAgeCheck = info > meta.parent.retirementAge;
    var lessThanOrEqualTo120 = info <= 120;
    return lifeExpectancyGreaterThanRetirementAgeCheck && lessThanOrEqualTo120 ? true : meta.createError({
      path: "".concat(meta.path),
      message: "Must be older than your retirement age and at most 120."
    });
  }),
  ssBenefit: yup.number().transform(_utils.parseCurrencyString).min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  incomeGoalPercent: yup.number().transform(parseFloat).required('Must be between 0% and 200% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 200% and to a maximum of 2 decimal places').max(200, 'Must be between 0% and 200% and to a maximum of 2 decimal places'),
  salaryGrowth: yup.number().transform(parseFloat).required('Must be between 0% and 10% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 10% and to a maximum of 2 decimal places').max(10, 'Must be between 0% and 10% and to a maximum of 2 decimal places'),
  inflationRate: yup.number().transform(parseFloat).required('Must be between 0% and 10% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 10% and to a maximum of 2 decimal places').max(10, 'Must be between 0% and 10% and to a maximum of 2 decimal places'),
  rorPostRetirement: yup.number().transform(parseFloat).required('Must be between 0% and 15% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 15% and to a maximum of 2 decimal places').max(15, 'Must be between 0% and 15% and to a maximum of 2 decimal places'),
  rorPreRetirement: yup.number().transform(parseFloat).required('Must be between 0% and 15% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 15% and to a maximum of 2 decimal places').max(15, 'Must be between 0% and 15% and to a maximum of 2 decimal places')
});
var validationConfigPageTwo = validationConfigPageOne.concat(validationConfigPageTwoAdditions);
var validationConfig = exports.validationConfig = [validationConfigPageOne, validationConfigPageTwo];
var intialValuesConfig = exports.intialValuesConfig = {
  birthMonth: '',
  birthDay: '',
  birthYear: '',
  annualPay: '',
  retirementAge: '67',
  contributionPercent: '',
  savings: '',
  incomeGoalPercent: _DefaultValues.defaultValues.incomeGoalPercent,
  inflationRate: _DefaultValues.defaultValues.inflationRate,
  lifeExpectancy: _DefaultValues.defaultValues.lifeExpectancy,
  rorPostRetirement: _DefaultValues.defaultValues.rorPostRetirement,
  rorPreRetirement: _DefaultValues.defaultValues.rorPreRetirement,
  salaryGrowth: _DefaultValues.defaultValues.salaryGrowth,
  ssBenefit: _DefaultValues.defaultValues.ssBenefit
};
var initialTouchedConfig = exports.initialTouchedConfig = {
  birthMonth: false,
  birthDay: false,
  birthYear: false
};